import DummyProvider from '@/services/query/providers/DummyProvider'
import AppSyncProvider from '@/services/query/providers/AppSyncProvider'

export default () => {
  return process.env.VUE_APP_ENABLE_DUMMY_API
    ? new DummyProvider()
    : new AppSyncProvider()
}
